import {Injectable} from '@angular/core';
import {RxJsWebSocketService} from './rxjs-websocket-service';
import {LocalApiService} from '../local-api/local-api.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Injectable()
export class StbWebSocketService {

  constructor(private rxJsWebSocketService?: RxJsWebSocketService, private localApiService?: LocalApiService) {
  }

  public openWebsocketToSTB(): Observable<any> {
    console.log('%c Connecting to the STB API...', 'color: green; background:yellow;font-size:16px;');
    return this.rxJsWebSocketService.createObservableSocket(this.localApiService.STB_WEBSOCKET_URL).pipe(map(
      data => {
        console.log(JSON.stringify(data));
        return true;
      }),
      catchError(err => {
        console.log('%c Error connecting to the stb API', 'color: white; background: red;font-size:16px');
        return of(false);
      })
    );
  }

  public sendProductActivationMessage(productIds: Array<string>, productName: string): Observable<boolean> {
    if (this.rxJsWebSocketService.isAvailable()) {
      console.log('websocket available to send');
      this.rxJsWebSocketService.sendMessage({
        edsProductId: productIds,
        commercialName: productName
      });
      return of(true);
    } else {
      console.log('Unable to send stb message. Connection not available.');
      return of(false);
    }
  }
}
